import { change } from 'redux-form'
/**
 * Just a simple hepler action that accepts an object
 * with field name as the key, and the updated value as the value ;)
 * I kinda think redux-form should ship this action creator, why not?
 *
 * https://github.com/erikras/redux-form/issues/2118
 *
 */
export function changeBulk (form, obj = {}) {
  return (dispatch) => {
    const fields = Object.keys(obj)
    fields.map(field => {
      dispatch(change(form, field, obj[field]))
    })
  }
}
